import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';

import * as MaintenanceReducer from "@app/maintenance/store/maintenance.reducer"
import { LoadActivitiesAction, LoadRecurrencesAction } from '@app/maintenance/store/maintenance.actions';
import { MaintenanceAccordionComponent } from '@app/maintenance/components/maintenance-accordion/maintenance-accordion.component';
import { TaskStatus } from '@app/shared/models/enums/task-status.enum';
import { TranslateService } from '@ngx-translate/core';
import { MaintenancePlanUtils } from '@app/shared/util/maintenance-plan.utils';
import { Activity } from "@models/activity.model";
import { PagedResponse } from "@models/response.model";
import * as _ from "lodash";
import { map } from "rxjs/operators";

@Component({
    selector: 'app-maintenance-plan-activities-form',
    templateUrl: './maintenance-plan-activities-form.component.html',
    styleUrls: ['./maintenance-plan-activities-form.component.scss']
})
export class MaintenancePlanActivitiesFormComponent implements OnInit, OnDestroy {
    @ViewChild(MaintenanceAccordionComponent, {static: false}) accordion: MaintenanceAccordionComponent;

    plan: any;
    activities = [];
    recurrences = [];

    activities$: Observable<any>;
    recurrences$: Observable<any>;

    activitiesSubscription: Subscription;
    recurrencesSubscription: Subscription;

    constructor(private store: Store<any>, private translate: TranslateService) {
        this.activities$ = this.store.pipe(select(MaintenanceReducer.getActivities), map(activities => _.cloneDeep(activities)));
        this.recurrences$ = this.store.pipe(select(MaintenanceReducer.getRecurrences), map(recurrences => _.cloneDeep(recurrences)));

        this.activitiesSubscription = this.activities$.subscribe((activities: PagedResponse<Activity>) => {
            if (activities) {
                this.activities = activities.items;
                this.activities.forEach(a => {
                    return {...a, items: []};
                });
                this.store.dispatch(new LoadRecurrencesAction());
            }
        });

        this.recurrencesSubscription = this.recurrences$.subscribe(recurrences => {
            if (recurrences) {
                this.recurrences = recurrences.items;
                this.setActivityItems();

                if (this.plan && this.plan.items) {
                    this.setSelectedItems();
                }
            }
        });
    }

    ngOnInit() {
        this.init();
    }

    init(plan = null) {
        this.plan = plan;
        this.store.dispatch(new LoadActivitiesAction());
    }

    get valid() {
        if (!(this.accordion && this.accordion.selectedItems.length > 0)) {
            return false;
        }

        let valid = true
        // every selected activity must contain at least one recurrence
        this.accordion.selectedItems.forEach(item => {
            if (!(item.selectedItems && item.selectedItems.length > 0)) {
                valid = false;
            } else {
                // every selected recurrence must contain at least one task
                item.selectedItems.forEach(si => {
                    if (!(si.selectedTasks && si.selectedTasks.length > 0)) {
                        valid = false;
                    }
                })
            }
        });

        return valid;
    }

    getFormValue() {
        return this.accordion.selectedItems;
    }

    reset() {
        this.accordion.resetSelected();
    }

    setActivityItems() {
        if (this.activities) {
            this.activities.forEach(a => {
                if (a.tasks && this.recurrences) {
                    a.tasks.forEach(t => t.status = TaskStatus.NEW);
                    const items = [];
                    this.recurrences.forEach(recurrence => items.push({
                        ...MaintenancePlanUtils.mapRecurrenceCard(recurrence,
                            this.translate.instant('admin.toolMaintenancePlans.recurrences.recurringEvery'), false),
                        tasks: a.tasks,
                        selectedTasks: []
                    }));

                    a.items = items;
                    a.selectedItems = [];
                }
            });
        }

    }

    setSelectedItems() {
        this.activities.forEach(a => {
            const activity = this.plan.items.find(item => item.id === a.id);
            if (activity) {
                a.selectedItems = activity.selectedItems;
                a.selectedItems.forEach(item => item.tasks = a.tasks);
                a.selected = true;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.activitiesSubscription) {
            this.activitiesSubscription.unsubscribe();
        }

        if (this.recurrencesSubscription) {
            this.recurrencesSubscription.unsubscribe();
        }
    }
}
